// ============================================================
// TN FOOD — Données entreprise centralisées
// Source : Kbis et statuts fournis par le client
// ============================================================

export const site = {
  name: "TN FOOD",
  legalForm: "Société par Actions Simplifiée (SAS)",
  capital: "1 000,00 €",
  address: {
    street: "34 Avenue du Général Gallieni",
    zip: "10300",
    city: "Sainte-Savine",
    country: "France",
    full: "34 Avenue du Général Gallieni, 10300 Sainte-Savine, France",
  },
  rcs: "RCS Troyes — n° de gestion 2023B00282",
  siren: "951 537 398",
  siret: "951 537 398 00012",
  ape: "5610C — Restauration de type rapide",
  tvaIntra: "FR 79 951537398",
  activityStart: "2023",
  president: "Monsieur NEJI Ali",
  phone: "07 75 77 29 51",
  phoneIntl: "+33 7 75 77 29 51",
  phoneHref: "tel:+33775772951",
  email: "contact@tnfood.food",
  domain: "tnfood.food",
  url: "https://tnfood.food",
  host: {
    name: "Namecheap, Inc.",
    address: "4600 East Washington Street, Suite 305, Phoenix, AZ 85034, États-Unis",
    phone: "+1 661 310 2107",
    site: "namecheap.com",
  },
  hours: {
    restaurant: "Mardi au dimanche : 11h30 – 14h30 et 18h30 – 22h30. Fermé le lundi.",
    traiteur: "Sur rendez-vous, du lundi au samedi de 9h00 à 19h00.",
  },
  zones: {
    livraison: ["Sainte-Savine", "Troyes", "La Chapelle-Saint-Luc", "Saint-André-les-Vergers", "Agglomération troyenne"],
    traiteur: "Toute la France (au départ de Sainte-Savine, près de Troyes)",
  },
  capacity: "40 couverts en salle + terrasse selon la saison",
  allergenNotice:
    "Liste des allergènes disponible sur demande. Conformément au règlement UE n° 1169/2011, notre personnel est à votre disposition pour vous communiquer la composition détaillée de nos plats.",
  payment: {
    restaurant: "Espèces, carte bancaire, titres-restaurant (Chèque Déjeuner, Ticket Restaurant, Edenred)",
    traiteur: "Acompte de 30 % à la réservation, solde 7 jours avant l'événement. Virement bancaire ou carte bancaire.",
  },
  mediator: {
    name: "CM2C — Centre de Médiation de la Consommation de Conciliateurs de Justice",
    address: "14 rue Saint Jean, 75017 Paris",
    phone: "01 89 47 00 14",
    email: "cm2c@cm2c.net",
    site: "www.cm2c.net",
  },
};

export const navLinks = [
  { to: "/", label: "Accueil" },
  { to: "/restaurant", label: "Restaurant" },
  { to: "/carte", label: "Carte" },
  { to: "/traiteur", label: "Traiteur" },
  { to: "/galerie", label: "Galerie" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];
